<div class="avatar-stack">
    <p-avatarGroup [class]="'avatar-group-' + size">
        <!-- Visible avatars -->
        @for (user of visibleUsers; track trackByUser($index, user)) {
        <p-avatar [image]="user | userAvatar" [pTooltip]="user | fullName" [class]="avatarSize + ' avatar-item' "
            shape="circle" tooltipPosition="bottom">
        </p-avatar>
        }

        <!-- Remaining count indicator -->
        @if (remainingCount > 0) {
        <p-avatar [label]="'+' + remainingCount" [pTooltip]="remainingCount + ' more users'"
            [class]="avatarSize + ' avatar-overflow'" class="bg-gray-500 text-white text-xs"
            [style]="{'font-size': '0.75rem'}" shape="circle" tooltipPosition="bottom">
        </p-avatar>
        }
    </p-avatarGroup>
</div>